











export default {
	name: 'EmptyState',

	props: {
		img: {
			default: null,
			required: false,
			type: String,
		},
		heading: {
			default: null,
			required: false,
			type: String,
		},
		message: {
			default: null,
			required: false,
			type: String,
		},
		panel: {
			default: false,
			required: false,
			type: Boolean,
		},
	},
};
